import { SVGProps } from 'react'

const LoadingIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M14.4992 7.00011C14.4992 10.8659 11.3654 13.9997 7.49962 13.9997C3.63384 13.9997 0.5 10.8659 0.5 7.00011C0.5 3.13433 3.63384 0.000488281 7.49962 0.000488281C11.3654 0.000488281 14.4992 3.13433 14.4992 7.00011ZM2.59307 7.00011C2.59307 9.70992 4.78981 11.9067 7.49962 11.9067C10.2094 11.9067 12.4062 9.70992 12.4062 7.00011C12.4062 4.2903 10.2094 2.09356 7.49962 2.09356C4.78981 2.09356 2.59307 4.2903 2.59307 7.00011Z'
                fill='url(#paint0_angular_803_34793)'
            />
            <circle cx='7.56972' cy='12.9498' r='1.04994' fill='#4DB0F1' />
            <defs>
                <radialGradient
                    id='paint0_angular_803_34793'
                    cx='0'
                    cy='0'
                    r='1'
                    gradientUnits='userSpaceOnUse'
                    gradientTransform='translate(7.49962 7.00011) rotate(90) scale(6.99962)'
                >
                    <stop stopColor='#4DB0F1' />
                    <stop offset='0.175675' stopColor='#4DB0F1' />
                    <stop offset='1' stopColor='white' stopOpacity='0' />
                </radialGradient>
            </defs>
        </svg>
    )
}
export default LoadingIcon
